let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4kdj2")).then(() => parcelRequire('jUPb8'));